import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { Button } from './ui/button';
import { openCalendly } from '../lib/analytics';

const FAQItem = ({ q, a, defaultOpen = false, testId }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="border border-border rounded-xl bg-card overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        data-testid={testId}
        className="w-full flex items-center justify-between gap-4 text-left p-5 sm:p-6 hover:bg-accent/40 transition-colors"
      >
        <span className="font-semibold text-foreground text-base sm:text-lg">{q}</span>
        <ChevronDown
          className={`w-5 h-5 flex-shrink-0 text-primary transition-transform ${
            open ? 'rotate-180' : ''
          }`}
        />
      </button>
      {open && (
        <div className="px-5 sm:px-6 pb-5 sm:pb-6 text-muted-foreground text-sm sm:text-base leading-relaxed">
          {a}
        </div>
      )}
    </div>
  );
};

const FAQSection = ({
  headline = 'Frequently Asked Questions',
  subhead = 'The questions Amazon brands ask us before booking a strategy call.',
  faqs = [],
  source = 'faq',
}) => {
  if (!faqs.length) return null;
  return (
    <section id="faq" className="py-16 sm:py-20 bg-background">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10 sm:mb-14">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-foreground">
              {headline}
            </h2>
            <p className="text-base sm:text-lg text-muted-foreground mt-3">{subhead}</p>
          </div>
          <div className="space-y-3 sm:space-y-4">
            {faqs.map((f, i) => (
              <FAQItem
                key={i}
                q={f.q}
                a={f.a}
                defaultOpen={i === 0}
                testId={`faq-item-${i}`}
              />
            ))}
          </div>
          <div className="mt-10 text-center">
            <p className="text-muted-foreground mb-4">Still have questions?</p>
            <Button
              onClick={() => openCalendly(source)}
              data-testid="faq-cta-btn"
              size="lg"
              className="bg-primary hover:bg-[hsl(var(--brand-hover))] text-primary-foreground font-semibold btn-brand-glow"
            >
              Book a Strategy Call
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
